import { linkToTeacherDashboard } from "../../links";

export function linkToClassPage(classId: string = ":classId") {
  return `${linkToTeacherDashboard()}/class/${classId}`;
}

export function linkToClassPageWithUnarchive(classId: string) {
  return `${linkToClassPage(classId)}?unarchive=true`;
}
